import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import ConventionViewStageAdmin from './view-stage-admin';

@observer
class ConventionViewAdmin extends Component {
    render() {
        const { stores, isInThePast, loadAll, drawerLevel } = this.props;
        return (
            <ConventionViewStageAdmin
                stores={stores}
                isInThePast={isInThePast}
                loadAll={loadAll}
                drawerLevel={drawerLevel}
            />
        );
    }
}

export default ConventionViewAdmin;
